import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import {
  UserFindRequest,
  UserRemoveRequest,
  UserSaveRequest,
  UserFindResponse,
  UserSearchRequest,
  UserSearchResponse,
  UserRemoveResponse,
  UserSaveResponse,
  UserFindAllResponse,
  UserFindAllRequest,
  UserProfileRequest,
  UserProfileResponse,
  UserDashboardResponse,
  UserActivateRequest,
  UserActivateResponse,
  UserDeactivateRequest,
  UserDeactivateResponse,
  UserResetPasswordRequest,
  UserResetPasswordResponse,
  UserUnlockRequest,
  UserUnlockResponse,
} from '../dto';

export abstract class UserRepository {
  abstract findAllPath(): string;
  abstract findAll(payload: UserFindAllRequest): Observable<HttpResponse<UserFindAllResponse>>;
  abstract dashboard(): Observable<HttpResponse<UserDashboardResponse>>;
  abstract find(payload: UserFindRequest): Observable<HttpResponse<UserFindResponse>>;
  abstract search(payload: UserSearchRequest): Observable<HttpResponse<UserSearchResponse>>;
  abstract save(payload: UserSaveRequest): Observable<HttpResponse<UserSaveResponse>>;
  abstract profile(payload: UserProfileRequest): Observable<HttpResponse<UserProfileResponse>>;
  abstract remove(payload: UserRemoveRequest): Observable<HttpResponse<UserRemoveResponse>>;
  abstract activate(payload: UserActivateRequest): Observable<HttpResponse<UserActivateResponse>>;
  abstract deactivate(
    payload: UserDeactivateRequest,
  ): Observable<HttpResponse<UserDeactivateResponse>>;
  abstract resetPassword(
    payload: UserResetPasswordRequest,
  ): Observable<HttpResponse<UserResetPasswordResponse>>;
  abstract unlock(payload: UserUnlockRequest): Observable<HttpResponse<UserUnlockResponse>>;
}


